/**
 * Pitch line layout presets for product-recommendation popups
 * when `setting.pitchLayout === true`.
 */

export const PITCH_TYPOGRAPHY = Object.freeze({
  labelFontSize: "10px",
  bodyFontSize: "14px",
  subtitleFontSize: "12px",
});

export const PITCH_LAYOUT = {
  CENTERED_CLASSIC: "centered-classic-v1",
  PREMIUM_RIBBON: "premium-ribbon-v1",
  SOFT_STRIP: "soft-strip-v1",
};

export const DEFAULT_PITCH_COLORS = Object.freeze({
  backgroundColor: "transparent",
  labelColor: "#57534e",
  textColor: "#0f172a",
  borderColor: "#a8a29e",
  dividerColor: "#a8a29e",
  badgeBackgroundColor: "transparent",
  pillBackgroundColor: "#f5f0eb",
  badgeTextColor: "#166534",
  iconBackgroundColor: "#292524",
  iconColor: "#ffffff",
  accentBackgroundColor: "#e8c4a8",
  accentIconColor: "#92400e",
});

export const DEFAULT_PITCH_DISPLAY = Object.freeze({
  layout: PITCH_LAYOUT.SOFT_STRIP,
  showBadge: true,
  showDivider: false,
  badgeText: "Handpicked to enhance your experience",
  iconUrl: "",
  colors: { ...DEFAULT_PITCH_COLORS },
});

export const PITCH_LAYOUT_CARDS = [
  {
    id: PITCH_LAYOUT.CENTERED_CLASSIC,
    title: "Serif centered",
    description: "Badge · title · sub — centered",
    icon: "✦",
    preview: "pitch-centered",
  },
  {
    id: PITCH_LAYOUT.PREMIUM_RIBBON,
    title: "Editorial card",
    description: "Icon · divider · pitch + badge",
    icon: "◇",
    preview: "pitch-ribbon",
  },
  {
    id: PITCH_LAYOUT.SOFT_STRIP,
    title: "Warm banner",
    description: "Cream strip · art accent",
    icon: "▭",
    preview: "pitch-strip",
  },
];

/**
 * @param {object | null | undefined} section
 */
export function getPitchLayoutDisplay(section) {
  const display = section?.setting?.display;
  const layout = display?.layout || DEFAULT_PITCH_DISPLAY.layout;
  const merged = {
    ...DEFAULT_PITCH_DISPLAY,
    ...display,
    layout,
    colors: {
      ...DEFAULT_PITCH_COLORS,
      ...(display?.colors || {}),
    },
  };

  if (!Object.values(PITCH_LAYOUT).includes(layout)) {
    return {
      ...DEFAULT_PITCH_DISPLAY,
      colors: { ...DEFAULT_PITCH_COLORS },
    };
  }

  return merged;
}

/**
 * @param {object | null | undefined} section
 */
export function getPitchThemeColors(section) {
  return getPitchLayoutDisplay(section).colors;
}

/**
 * @param {object | null | undefined} section
 */
export function isPitchLayoutSection(section) {
  return section?.type === "TEXT" && section?.setting?.pitchLayout === true;
}

/**
 * Layouts that support a custom icon image in the editor.
 * @param {string} layout
 */
export function pitchLayoutSupportsIconImage(layout) {
  return (
    layout === PITCH_LAYOUT.PREMIUM_RIBBON || layout === PITCH_LAYOUT.SOFT_STRIP
  );
}
